import Vue from "vue";
import "./plugins/vuetify";
import App from "@/App.vue";
import router from "./router";
import "./registerServiceWorker";
import store from "./store";
import { Comms } from "./utilities/comms";
import axios from "axios";

Vue.config.productionTip = false;
Vue.prototype.$com = new Comms("https://sqe-api.deadseascrolls.org.il/signalr", null);
Vue.prototype.$http = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
